var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"label":_vm.$t('message.Search'),"append-icon":"search","spellcheck":"false","single-line":"","hide-details":"","clearable":"","solo":"","filled":"","dense":"","rounded":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})
}
var staticRenderFns = []

export { render, staticRenderFns }